export const AppSettings = {
    
    AppName: 'Markets by App',
    
    TokenKey: 'SLOOLLLLSOOIAIKSJKFP66A8S9F9ASZZDSDAKSKKJJSS',

    EndPoint: 'https://endpoint.api.travelerscr.com/api'

}
